import $ from 'jquery';
import * as helpers from './helpers';
import {els, constants, breakpoints} from './variables';

let expandSliders;
let expandSliderSettings;
const expandItems = $('.expand-grid .expand-item.has-children');
const expandSliderBreakpoint = breakpoints.xs;

function toggleExpandItem(expandItem) {
	expandItem.toggleClass('is-collapsed');
	expandItem.toggleClass('is-expanded');
}

function initExpandGrid(e) {

	expandItems.find('.expand-group__trigger').click(function(e) {
		const targetItem = $(this).closest('.expand-item');
		const activeItem = targetItem.siblings('.is-expanded');

		toggleExpandItem(targetItem);
		if(targetItem !== activeItem) {
			toggleExpandItem(activeItem);
		}

		helpers.scrollToEl(targetItem, 0, 300);
	});

	expandItems.find('.expand__close').click(function() {
		const targetItem = $(this).closest('.expand-item');
		targetItem.addClass('is-collapsed').removeClass('is-expanded');
	});
}

function initExpandSliders(e) {
	expandSliders = $(".expand-group .ib-grid");
	expandSliderSettings = {
		infinite: true,
		slidesToShow: 2,
		speed: constants.speed,
		cssEase: constants.easing,
		prevArrow: "<span class='carousel-control prev'><i class='fa fa-angle-left'></i></span>",
		nextArrow: "<span class='carousel-control next'><i class='fa fa-angle-right'></i></span>"
	};
	expandSliders.slick(expandSliderSettings);
	handleExpandGridView(e);
}

function handleExpandGridView(e) {
	if (els.viewport.width() > expandSliderBreakpoint) {
		if (expandSliders.hasClass('slick-initialized')) {
			expandSliders.slick('unslick');
		}
		return;
	}

	if (!expandSliders.hasClass('slick-initialized')) {
		return expandSliders.slick(expandSliderSettings);
	}
}

window.addEventListener('load', (e) => {
	initExpandGrid(e);
	initExpandSliders(e);
});

window.addEventListener('resize', helpers.debounce(handleExpandGridView));
